// extracted by mini-css-extract-plugin
export default {"root":"CourseWareViewer_root__kXBoG","center":"CourseWareViewer_center__B-wfT"};